<template>
  <div :class="['tva-image-lazy', config.imageSize]">
    <img v-lazy="`${baseUrl}${content.src}`" />
  </div>
</template>
<script>
export default {
  props: ["content", "config"],
  data() {
    return {
      baseUrl: process.env.BASE_URL
    };
  }
};
</script>
<style lang="scss" scoped>
.tva-image-lazy {
  &.fullScreen {
    //da sistemare in base al contenitore
    width: calc(100% + 10em);
    position: relative;
    top: 0;
    left: -5em;
    img {
      width: 100% !important;
    }
  }
  &.maxWidth {
    //max width contenitore
    width: 100%;
    img {
      width: 100% !important;
    }
  }
}
</style>
